import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store/index'
import { Provider } from 'react-redux'
import reportWebVitals from './reportWebVitals';
import { ToastProvider } from './components/ToastProvider';
import { HelmetProvider } from 'react-helmet-async';

// iOS Safari pull-to-refresh guard that activates when body has 'no-ptr'
// Only prevents when the nearest scrollable container is at scrollTop=0 and user pulls down
(() => {
  let startY = 0;
  let maybePreventPullToRefresh = false;
  let activeScroller = null;
  const isIOS = typeof window !== 'undefined'
    && /iP(ad|hone|od)/.test(window.navigator.userAgent);
  if (!isIOS) return;

  const getScrollableAncestor = (el) => {
    let node = el;
    while (node && node !== document.body) {
      const style = window.getComputedStyle(node);
      const overflowY = style.overflowY;
      const isScrollable =
        (overflowY === 'auto' || overflowY === 'scroll') &&
        node.scrollHeight > node.clientHeight;
      if (isScrollable) return node;
      node = node.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  };

  window.addEventListener('touchstart', (e) => {
    if (!document.body.classList.contains('no-ptr')) return;
    if (e.touches.length !== 1) return;
    startY = e.touches[0].clientY;
    activeScroller = getScrollableAncestor(e.target);
    const top = activeScroller ? activeScroller.scrollTop : window.pageYOffset;
    maybePreventPullToRefresh = top <= 0;
  }, { passive: true });

  window.addEventListener('touchmove', (e) => {
    if (!document.body.classList.contains('no-ptr')) return;
    if (!maybePreventPullToRefresh) return;
    const curY = e.touches[0].clientY;
    const isPullingDown = curY > startY;
    const scrollerTop = activeScroller ? activeScroller.scrollTop : window.pageYOffset;
    if (isPullingDown && scrollerTop <= 0) {
      // Prevent iOS Safari pull-to-refresh
      e.preventDefault();
      // Stop iOS rubber-band bounce
      if (activeScroller && activeScroller !== document.scrollingElement) {
        activeScroller.scrollTop = 0;
      } else {
        window.scrollTo(0, 0);
      }
    }
  }, { passive: false });

  window.addEventListener('touchend', () => {
    maybePreventPullToRefresh = false;
    activeScroller = null;
  }, { passive: true });
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <HelmetProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </HelmetProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();